module.exports = __webpack_public_path__ + "static/media/vip_level_1.4bd9da29.png";